'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'cat';
var width = 576;
var height = 512;
var aliases = [128008];
var unicode = 'f6be';
var svgPathData = ['M178.7 254c13.1-14.3 28.4-26.5 45.3-36.3l0 70.2c-15.1-11.3-30.2-22.7-45.3-34zm52.8-40.4c17.4-9.1 36.4-15.6 56.5-18.9l0 61.2c-18.8-14.1-37.7-28.2-56.5-42.4z', 'M64 96c53 0 96 43 96 96l0 85.8c5.6-8.4 11.9-16.4 18.7-23.8l45.3 34 0-70.2c2.5-1.4 5-2.8 7.5-4.1l56.5 42.4 0-61.2c1.8-.3 3.6-.6 5.4-.9 25.6 60 85.2 102.1 154.6 102.1 10.9 0 21.6-1.1 32-3.1l0 219.1-64 0 0-172.8-136 108.8 88 0 0 64-272 0 0-320c0-17.7-14.3-32-32-32l-32 0 0-64 32 0zm496 32c0 61.9-50.1 112-112 112S336 189.9 336 128l0-146.7 80 66.7 64 0 80-66.7 0 146.7zM400 108a20 20 0 1 0 0 40 20 20 0 1 0 0-40zm96 0a20 20 0 1 0 0 40 20 20 0 1 0 0-40z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCat = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;